class FAQAccordionLinks extends HTMLElement {
  constructor() {
    super();
    this.setupLinkHandlers();
    this.setupAccordionClickHandlers();
    this.checkInitialHash();
  }
  
  setupLinkHandlers() {
    // Listen for clicks on the entire document
    document.addEventListener('click', this.handleLinkClick.bind(this));
  }
  
  setupAccordionClickHandlers() {
    document.addEventListener('click', this.handleAccordionClick.bind(this));
  }
  
  handleAccordionClick(event) {
    const summary = event.target.closest('.faq__question');
    if (!summary) return;
    
    const accordion = summary.closest('.faq__item');
    if (!accordion) return;
    
    if (!accordion.open) {
      this.closeAllOtherAccordions(accordion);
    }
  }
  
  closeAllOtherAccordions(excludeAccordion) {
    const allOpenAccordions = document.querySelectorAll('.faq__item[open]');
    allOpenAccordions.forEach(accordion => {
      if (accordion !== excludeAccordion) {
        accordion.open = false;
      }
    });
  }
  
  handleLinkClick(event) {
    const link = event.target.closest('a');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#!')) return;
    
    event.preventDefault();
    
    // Extract the accordion ID from the href (remove #!)
    const accordionId = href.substring(2);
    this.openAccordion(accordionId);
  }
  
  openAccordion(accordionId) {
    const accordion = document.getElementById(accordionId);
    if (!accordion || accordion.tagName !== 'DETAILS') return;
    
    this.closeAllOtherAccordions(accordion);
    
    // Check if accordion is hidden by "See More"
    if (accordion.classList.contains('faq__item--hidden')) {
      // Find and click the "See More" button
      const section = accordion.closest('.faq');
      const seeMoreButton = section?.querySelector('.faq__see-more');
      if (seeMoreButton) {
        seeMoreButton.click();
      }
    }
    
    // Open the accordion
    accordion.open = true;
    
    // Scroll to the accordion with some offset
    const yOffset = -100; // Adjust this value to control scroll offset
    const y = accordion.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
  
  checkInitialHash() {
    // Check if the URL has a hash that starts with !
    const hash = window.location.hash;
    if (hash && hash.startsWith('#!')) {
      const accordionId = hash.substring(2);
      // Wait for the page to fully load
      setTimeout(() => {
        this.openAccordion(accordionId);
      }, 100);
    }
  }
}

customElements.define('faq-accordion-links', FAQAccordionLinks);